import baseService from '../shared/baseService';

const vehicleClientService = (clientId: number) => baseService(`clients/${clientId}/vehicles`);
const vehicleClientServiceDownload = (clientId: number) => baseService('clients').download(`/${clientId}/vehicles/download`);

export default { 
    vehicleClientService,
    vehicleClientServiceDownload
};

